import React from 'react'
import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
    useSmartProp,
} from '@smartfire/js-block-engine'
import { EditableHeading } from '@smartfire/components'
import { EventTile, TaxonomyNavigation } from '../../components'
import { mobileType } from '../../components/posts/Tile'
import { useMediaQuery } from '../../hooks'
import { postEventsParams, eventCategoryTaxonomyProps } from '../../types'
import style from './block.module.scss'
import clsx from 'clsx'
import Inspector from './Inspector'

type HomeEventsProps = {
    filter: boolean
    link: string
}

const HomeEvents: React.FC<HomeEventsProps> = ({ filter, link }) => {
    const { isEditing } = useEditor()
    useInspectorControl(Inspector, [])
    const [events] = useSmartProp<postEventsParams[]>('events')
    const [categories] = useSmartProp<eventCategoryTaxonomyProps[]>('categories')
    const [eventsArchiveLink] = useSmartProp('eventsArchiveLink')
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    return (
        <BlockWrapper.Div className={clsx(style.block, isEditing && style.admin)}>
            <div className={style.head}>
                {/* @ts-ignore */}
                <EditableHeading
                    className={style.title}
                    smartProp={'title'}
                    placeholder={'Titre...'}
                />
                {!filter ? (
                    <TaxonomyNavigation
                        terms={categories}
                        seeMoreLink={eventsArchiveLink}
                        seeMoreText={!isMobile ? 'Voir tout' : 'Voir tous les événements'}
                        showTerms={!isMobile}
                    />
                ) : (
                    <a href={link} className={style.seeAll}>
                        Voir tous les événements <i className="fi-rs-arrow-right" />
                    </a>
                )}
            </div>

            <div className={style.events}>
                {events &&
                    events.map((post) => (
                        <EventTile key={post.id} post={post} mobile={mobileType.minify} />
                    ))}
            </div>
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: HomeEvents,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: 'Les Événements',
        }),
        events: smartProps.array.withDefault([]).contentServerSide(),
        categories: smartProps.array.withDefault([]).contentServerSide(),
        eventsArchiveLink: smartProps.string.withDefault('').contentServerSide(),
        filter: smartProps.bool.withDefault(false),
        termID: smartProps.number.withDefault(-1),
        link: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Events - Home Events',
    },
})
